/**
 * ThemeToggle — centralized copy strings (AOF 25, i18n posture).
 */

export const themeToggleCopy = {
  toggleContrastLabel: "toggle high contrast",
  normalGlyph: "◐",
  highGlyph: "◉",
  normalText: "normal",
  highText: "high",
} as const;
